---
de:
  power_plant_responsible:
    delete_confirm_text: Sind Sie sicher, dass Sie diesen Verantwortlichen vom Kraftwerk entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.
    delete_confirm_title: Kraftwerks-Verantwortlichen entfernen
  responsible:
    add: Verantwortlichen hinzufügen
    already_linked_description: Diese verantwortliche Person ist bereits mit einem Benutzerkonto verknüpft. Sie können Namen und Telefon aktualisieren, aber die Verknüpfung zum Benutzer nicht aufheben.
    already_linked_title: Bereits mit Benutzer verknüpft
    auto_switched_description: Wir haben automatisch zum "Mit Benutzer verknüpfen"-Modus gewechselt, da diese E-Mail mit einem bestehenden Benutzerkonto übereinstimmt.
    create_mode_description: Sie erstellen eine neue verantwortliche Person. Füllen Sie das untenstehende Formular aus und speichern Sie, um die neue Person zu erstellen.
    create_mode_title: Neue verantwortliche Person erstellen
    create_new: Neu erstellen
    delete_confirm_text: Sind Sie sicher, dass Sie diesen Verantwortlichen löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.
    delete_confirm_title: Verantwortlichen löschen
    deleted_completely: "%{name} wurde vollständig aus dem System entfernt."
    deleted_preserved: "%{name} wurde von diesem Unternehmen entfernt, aber aufgrund anderer Verbindungen (Benachrichtigungen, Arbeitsaufträge usw.) im System behalten."
    edit: Verantwortlichen bearbeiten
    edit_mode_description: Sie bearbeiten nun die Details der verantwortlichen Person. Füllen Sie das untenstehende Formular aus und speichern Sie, um die Informationen zu aktualisieren.
    edit_mode_title: Bearbeitungsmodus aktiv
    edit_plural: Verantwortliche bearbeiten
    edit_power_plant_responsible: Verantwortlichen für Kraftwerk bearbeiten
    edit_tooltip: Verantwortliche Person bearbeiten oder neu erstellen
    email_from_linked_user: E-Mail vom verknüpften Benutzerkonto
    email_match_detected_title: E-Mail-Übereinstimmung erkannt
    link_to_user: Mit Benutzer verknüpfen
    linked_to_user: Mit Benutzer verknüpft
    matched_user: 'Übereinstimmender Benutzer:'
    must_have_name_email: Verantwortlicher muss entweder Name oder E-Mail haben
    phone_change_warning_description: Die Änderung dieser Telefonnummer wird sie für das verknüpfte Benutzerkonto überall im System aktualisieren.
    phone_change_warning_title: Warnung vor Benutzer-Telefon-Aktualisierung
    phone_from_matched_user: Telefonnummer vom übereinstimmenden Benutzerkonto
    responsible: Verantwortlicher
    responsibles: Verantwortliche
    role: Rolle
    save_and_link: Speichern und mit Benutzer verknüpfen
    select_responsible: Verantwortliche Person auswählen
    task_responsible: Zugang zur Aufgabenverwaltung
